import React from 'react';

const DeleteIcon = ({ width = 18, height = 18, color = 'currentColor', ...rest }) => (
  <svg
    viewBox="0 0 19 20"
    width={width}
    height={height}
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...rest}
  >
    {/* top bar */}
    <path d="M18.234 5.982H.85a.85.85 0 0 1 0-1.7h17.384a.85.85 0 1 1 0 1.7" />
    {/* lid */}
    <path d="M6.61 4.281h6.235V2.397a.697.697 0 0 0-.696-.696H7.307a.697.697 0 0 0-.696.696v1.884zm7.937 1.701H4.91V2.397A2.4 2.4 0 0 1 7.307 0h4.842a2.4 2.4 0 0 1 2.398 2.397v3.585z" />
    {/* body */}
    <path d="M14.592 20.005H4.694a2.584 2.584 0 0 1-2.581-2.581v-9.24a.85.85 0 1 1 1.7 0v9.24c0 .485.395.88.88.88h9.899a.88.88 0 0 0 .879-.88v-9.24a.851.851 0 1 1 1.702 0v9.24a2.584 2.584 0 0 1-2.581 2.58" />
    {/* left line */}
    <path d="M7.759 16.22a.851.851 0 0 1-.851-.852v-5.095a.851.851 0 1 1 1.702 0v5.095c0 .47-.381.851-.851.851" />
    {/* right line */}
    <path d="M11.526 16.22a.851.851 0 0 1-.85-.852v-5.095a.851.851 0 1 1 1.701 0v5.095c0 .47-.38.851-.85.851" />
  </svg>
);

export default DeleteIcon;
